import C from '../../../constants';
import {involvement} from './involvementReducer';

export const owner = (state = {}, action) => {
    switch (action.type) {
        case C.SET_OWNER:
            return {
                ...state,
                ...action.payload
            };

        case C.SET_OWNER_PROPERTIES:
            return {
                ...state,
                properties: action.payload
            };

        case C.EDIT_PROPERTY_LISTING:
            let propId = action.payload.propId;
            let listing = action.payload.listing;
            return {
                ...state,
                properties: state.properties.map((property) => {
                    if (property.id === propId) {
                        return {
                            ...property,
                            active_listing: {
                                ...property.active_listing,
                                ...listing
                            }
                        }
                    } else {
                        return property;
                    }
                })
            };

        case C.ADD_PROPERTY:
            let props = state.properties;
            props.push(action.payload);
            return {
                ...state,
                properties: props
            };

        case C.SET_OWNER_INVOLVEMENT:
            return {...state, involvement: involvement(state.involvement, action)};

        case C.SET_PROPERTY_LISTINGS:
            return state;

        case C.SET_PROPERTY_ROOMMATE_GROUPS:
            const containsApplication = state.applications.find((application) => {
                return application.prop_id === action.payload.prop_id && application.listing_id === action.payload.listing_id;
            });

            return containsApplication ? {
                ...state,
                applications: state.applications.map((app) => {
                    return (app.prop_id === action.payload.prop_id && app.listing_id === action.payload.listing_id) ? {
                        ...action.payload,
                        roommate_groups: action.payload.roommate_groups.map((group) => {
                            let sum = 0;
                            for (let i = 0; i < group.roommates.length; i++) {
                                sum += group.roommates[i].rentability_score;
                            }
                            group.average_score = Math.round((sum / group.roommates.length), 1);
                            return group;
                        })
                    } : app;
                })
            } : {
                ...state,
                applications: [...state.applications, {
                    ...action.payload,
                    roommate_groups: action.payload.roommate_groups.map((group) => {
                        let sum = 0;
                        for (let i = 0; i < group.roommates.length; i++) {
                            sum += group.roommates[i].rentability_score;
                        }
                        group.average_score = Math.round((sum / group.roommates.length), 1);
                        return group;
                    })
                }]
            };

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/containers/owner/reducers/ownerReducer.js